// Owner-confirmed identity. Never infer free access from an editable school name.
export const LIFETIME_FREE_DOJO_ID = '73b9c11e-c3d0-4c06-9de4-f990a63c3d2e';
export const hasLifetimeAccess = (dojoId: string | null | undefined): boolean =>
  dojoId === LIFETIME_FREE_DOJO_ID;
